import { obterFaviconSistema } from "../api/sistema";
import { EVENTO_ASSETS_SISTEMA } from "./configuracoesSistema";
import { lerEmpresaLoginSelecionada } from "../theme/empresaLogin";

declare global {
  interface Window {
    __i9FaviconSistemaInicializado?: boolean;
  }
}

const FAVICON_LINK_ID = "faviconLink";
const FAVICON_SHORTCUT_ID = "faviconShortcutLink";
const FAVICON_STORAGE_KEY = "logoFavicon";

function sanitizarImagemLogo(valor: string | null | undefined): string {
  const v = String(valor || "").trim();
  if (!v) return "";

  const vLower = v.toLowerCase();
  if (vLower === "undefined" || vLower === "null" || vLower === "nan") return "";
  if (vLower.includes("id=undefined") || vLower.includes("id=null") || vLower.includes("id=&")) return "";

  if (
    !/^https?:\/\//i.test(v) &&
    !/^data:image\//i.test(v) &&
    !/^\/api\/assets\//i.test(v) &&
    !/^\/uploads\//i.test(v)
  ) {
    if (/^\d+$/.test(v)) return `/api/assets/${v}`;
    if (!/^[a-zA-Z0-9_-]{10,}$/.test(v)) return "";
    return `/uploads/${v}`;
  }

  return v;
}

function obterOuCriarLinkFavicon(id: string, rel: string): HTMLLinkElement | null {
  if (typeof document === "undefined") return null;

  const existente = document.getElementById(id);
  if (existente instanceof HTMLLinkElement) return existente;

  const link = document.createElement("link");
  link.id = id;
  link.rel = rel;
  document.head.appendChild(link);
  return link;
}

function aplicarHref(link: HTMLLinkElement | null, url: string) {
  if (!link) return;
  if (link.getAttribute("href") === url) return;
  link.setAttribute("href", url);
}

function limparHref(link: HTMLLinkElement | null) {
  if (!link) return;
  link.removeAttribute("href");
}

function aplicarFavicon(url: string) {
  const normalizado = sanitizarImagemLogo(url);
  if (!normalizado) return;

  aplicarHref(obterOuCriarLinkFavicon(FAVICON_LINK_ID, "icon"), normalizado);
  aplicarHref(obterOuCriarLinkFavicon(FAVICON_SHORTCUT_ID, "shortcut icon"), normalizado);
}

function limparFavicon() {
  if (typeof document === "undefined") return;
  limparHref(obterOuCriarLinkFavicon(FAVICON_LINK_ID, "icon"));
  limparHref(obterOuCriarLinkFavicon(FAVICON_SHORTCUT_ID, "shortcut icon"));
}

function salvarFaviconLocal(url: string) {
  if (typeof window === "undefined") return;

  try {
    localStorage.setItem(FAVICON_STORAGE_KEY, url);
  } catch {
    /* ignora indisponibilidade do localStorage */
  }
}

function removerFaviconLocal() {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem(FAVICON_STORAGE_KEY);
  } catch {
    /* ignora indisponibilidade do localStorage */
  }
}

function aplicarFaviconSalvo() {
  if (typeof window === "undefined") return;

  try {
    const favicon = sanitizarImagemLogo(localStorage.getItem(FAVICON_STORAGE_KEY));
    if (!favicon) {
      removerFaviconLocal();
      limparFavicon();
      return;
    }

    aplicarFavicon(favicon);
  } catch {
    /* ignora indisponibilidade do localStorage */
  }
}

async function sincronizarFaviconSistema() {
  aplicarFaviconSalvo();

  try {
    const dados = await obterFaviconSistema(lerEmpresaLoginSelecionada());
    const favicon = sanitizarImagemLogo(dados.url || dados.id);

    if (!favicon) {
      removerFaviconLocal();
      limparFavicon();
      return;
    }

    salvarFaviconLocal(favicon);
    aplicarFavicon(favicon);
  } catch {
    /* mantem o favicon salvo localmente */
  }
}

export function inicializarFaviconSistema() {
  aplicarFaviconSalvo();

  if (typeof window === "undefined") return;
  if (window.__i9FaviconSistemaInicializado) {
    void sincronizarFaviconSistema();
    return;
  }

  window.__i9FaviconSistemaInicializado = true;
  window.addEventListener(EVENTO_ASSETS_SISTEMA, () => {
    void sincronizarFaviconSistema();
  });

  void sincronizarFaviconSistema();
}
